<template>
  <MainLayout>
    <div class="card">
      <div class="py-10 d-block card-header">
        <h1>{{ pageTitle }}</h1>
      </div>

      <div class="card-body">
        <h2> Insira os dados da Campanha </h2>
        <form @submit.prevent="submit" class="mt-2">

          <div class="col-lg-6">
            <div class="mt-8 col-lg-10">
              <!--begin: name -->
              <div class="form-group mb-3">
                <p class="mt-2"> <strong>Nome da campanha:</strong> </p>
                <input type="text" class="form-control" placeholder="Ex: Campanha de teste" v-model.trim="$v.form.name.$model"/>
              </div>
              <!--end: name -->
              <!--begin: advertiser -->
              <div class="form-group mb-3">
                <label for="advertiser" class="mt-2"> <strong>Anunciante:</strong> </label>
                <SelectAdvertiserInput
                  v-model="$v.form.advertiser_id.$model"
                  v-if="!isEditPage"
                />
                <input type="text" class="form-control" :value="campaign.advertiser.name" v-if="campaign" disabled />
              </div>
              <!--begin: budget -->
              <div class="form-group mb-3">
                <p class="mt-2"> <strong>Tipo de campanha:</strong> </p>
                <select class="form-select" v-model.trim="$v.form.type.$model" :disabled="isEditPage">
                  <option value="">Selecione</option>
                  <option value="NATIVE">Native</option>
                  <option value="PROGRAMMATIC">Programática</option>
                </select>
              </div>
              <!--end: type -->
              <!--end: advertiser -->
              <div class="d-flex gap-10 col-lg-12">
                <!--begin: start date -->
                <div class="form-group mb-3">
                  <p class="mt-2"> <strong>Períodos:</strong> </p>
                  <div class="d-flex gap-5">
                    <DateTimeInput
                      v-model.trim="$v.form.start_date.$model"
                      format="dd/MM/yyyy"
                      type="date"
                      theme="basic"
                      placeholder="Início"
                    />
                    <DateTimeInput
                      v-model.trim="$v.form.end_date.$model"
                      format="dd/MM/yyyy"
                      type="date"
                      theme="basic"
                      placeholder="Término"
                    />
                  </div>
                </div>
                <!--end: start date -->
              </div>
              <!--begin: budget -->
              <div class="form-group mb-3">
                <p class="mt-2"> <strong>Orçamento total:</strong> </p>
                <Money
                  class="form-control mb-3"
                  v-model.trim="$v.form.amount.$model"
                  v-bind="money"
                />
              </div>
              <!--end: budget -->
              <!--begin: creative -->
              <div class="mb-3">
                <label for="advertiser" class="mt-2"> <strong>Criativo(s):</strong> </label>
                <VueMultiselect
                  id="advertiser"
                  label="label"
                  track-by="code"
                  v-model="$v.form.creative_ids.$model"
                  :options="filteredCreatives"
                  :multiple="true"
                >
                </VueMultiselect>
              </div>
              <!--end: creative -->
              <!--begin: exchange rate -->
              <div class="form-group mb-3">
                <p class="mt-2"> <strong>Taxa de câmbio:</strong> </p>
                <Money
                  class="form-control mb-3"
                  v-model.trim="$v.form.exchange_rate_amount.$model"
                  v-bind="money"
                />
              </div>
              <!--end: exchange rate -->
              <!--begin: retention -->
              <div class="form-group mb-3" v-if="1 == 2">
                <p class="mt-2"> <strong>Retenção:</strong> (apenas números inteiros) </p>
                <input
                  type="text"
                  class="form-control mb-3"
                  v-model.trim="$v.form.retention.$model"
                />
              </div>
              <!--end: retention -->
            </div>
          </div>
          <div class="mt-10 text-center">
            <Button
              type="submit"
              class="btn btn-primary"
              :disabled="$v.invalid"
              :loading="loader"
            >
              Enviar
            </Button>
          </div>
        </form>
      </div>
    </div>
  </MainLayout>
</template>

<script>

import CreativesService from '@/modules/creatives/services/creatives-service'
import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import NotificationsService from '@/modules/notifications/services/notifications-service'
import { minLength, minValue, required } from 'vuelidate/lib/validators'

import MainLayout from '@/components/layouts/MainLayout.vue'
import Button from '@/components/common/Button/Button.vue'
import VueMultiselect from 'vue-multiselect'
import { Money } from 'v-money'
import DateTimeInput from '@/components/common/Input/DateTimeInput.vue'
import SelectAdvertiserInput from '@/components/advertisers/SelectAdvertiserInput.vue'

export default {
  props: ['companyId'],
  components: {
    SelectAdvertiserInput,
    DateTimeInput,
    Button,
    MainLayout,
    VueMultiselect,
    Money
  },
  data () {
    return {
      advertisers: [],
      campaign: null,
      creatives: [],
      form: {
        advertiser_id: '',
        amount: 0,
        creative_ids: [],
        end_date: '',
        exchange_rate_amount: 0,
        name: '',
        platform: '',
        retention: 0,
        start_date: '',
        type: ''
      },
      loader: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  validations () {
    return {
      form: {
        advertiser_id: { required },
        amount: { required, minValue: minValue(1) },
        creative_ids: { required, minLength: minLength(1) },
        end_date: { required },
        exchange_rate_amount: { required },
        name: { required },
        retention: { required },
        start_date: { required },
        type: { required }
      }
    }
  },
  created () {
    if (this.isEditPage) this.getCampaign()
  },
  watch: {
    /**
     * Get advertisers available creatives when form has an advertiser_id
     * @param newValue
     */
    'form.advertiser_id' (newValue) {
      this.getCreatives(newValue)
    }
  },
  computed: {
    /**
     * Gets available creatives
     */
    filteredCreatives () {
      if (!this.creatives) {
        return []
      }

      return this.creatives.map(creative => {
        const nome = creative.name
        const platformId = creative.google_id ?? creative.yahoo_id ?? creative.meta_id ?? creative.amazon_id ?? ''
        return {
          label: `${nome} - ${platformId}`,
          code: creative.id
        }
      })
    },
    /**
     * Is edit page
     * @returns {boolean}
     */
    isEditPage () {
      return this.$route.name === 'campaigns.edit'
    },
    /**
     * Page title
     * @returns {string}
     */
    pageTitle () {
      return this.isEditPage ? 'Editar campanha' : 'Criar campanha manual'
    }
  },
  methods: {
    /**
     * Get campaign
     * @returns {Promise<void>}
     */
    async getCampaign () {
      this.loader = true
      try {
        this.campaign = await CampaignsService.getCampaign(this.$route.params.id)
        this.setCampaign()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Get creatives
     */
    async getCreatives (advertiserId) {
      if (!advertiserId) return false

      this.loader = true
      try {
        const creatives = await CreativesService.getCreatives({
          advertiser_id: advertiserId,
          items_per_page: 100
        })
        this.creatives = creatives.data
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Set campaign
     */
    setCampaign () {
      this.form.advertiser_id = this.campaign.advertiser.id
      this.form.name = this.campaign.name
      this.form.amount = this.campaign.amount / 100
      this.form.start_date = this.campaign.start_date
      this.form.end_date = this.campaign.end_date
      this.form.exchange_rate_amount = this.campaign.exchange_rate_amount / 100
      this.form.retention = this.campaign.retention
      this.form.type = this.campaign.type
      if (this.campaign.type === 'NATIVE') {
        this.form.creative_ids = [
          ...this.campaign.creatives.creatives.map(creative => {
            return {
              code: creative.id,
              label: creative.name
            }
          }),
          ...this.campaign.creatives.square_creatives.map(creative => {
            return {
              code: creative.id,
              label: creative.name
            }
          })
        ]
      } else if (this.campaign.type === 'PROGRAMMATIC') {
        this.form.creative_ids = [
          ...this.campaign.packages[0].lines[0].creatives.map(creative => {
            return {
              code: creative.id,
              label: creative.name
            }
          })
        ]
      }
      this.getCreatives(this.form.advertiser_id)
    },
    /**
     * Send form
     * @returns {Promise<void>}
     */
    async submit () {
      const creativeIds = this.form.creative_ids.map(creative => creative.code)

      const data = {
        name: this.form.name,
        advertiser_id: this.form.advertiser_id,
        amount: this.form.amount * 100,
        creative_ids: creativeIds,
        end_date: this.form.end_date,
        exchange_rate_amount: this.form.exchange_rate_amount * 100,
        retention: this.form.retention,
        start_date: this.form.start_date,
        type: this.form.type
      }
      this.loader = true
      try {
        let campaign = null
        if (this.isEditPage) {
          campaign = await CampaignsService.updateCampaign(this.campaign.id, data)
        } else {
          campaign = await CampaignsService.createCampaign(data)
        }
        NotificationsService.createGlobalSuccessQuickNotification(`Campanha ${this.isEditPage ? 'editada' : 'criada'} com sucesso!`)
        this.$router.push({ name: 'campaigns.show', params: { id: campaign.id } })
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
<style lang="css" src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
